const Instagram = ({ url }) => {
  return (
    <iframe
      src={url}
      title="instagram"
      frameborder="0"
      width="100%"
      height="1000"
    ></iframe>
  );
};

export default Instagram;
